<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="手机号：">
            <el-input
              v-model="query.pho"
              placeholder="请输入手机号"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input
              v-model="query.goodsName"
              placeholder="请输入商品名称"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="快递单号：">
            <el-input
              v-model="query.logisticsNumber"
              placeholder="请输入快递单号"
              clearable
              size="small"
            />
          </el-form-item>
          <el-form-item label="申请时间：">
            <el-date-picker
              v-model="dateTime"
              size="small"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini"
              >搜索</el-button
            >
            <el-button type="info" @click="handleFilter" plain size="mini"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain
            >下载模版</el-button
          >
          <el-upload
            v-hasPermi="['meeting:record:import']"
            style="display: inline-block;margin:0 5px"
            :action="uploadImgUrl"
            :show-file-list="false"
            :http-request="uploadFile"
            :file-list="fileList"
          >
            <el-button size="mini" type="primary">导入</el-button>
          </el-upload>
          <el-button type="primary" size="mini" @click="handleAdd" plain
            >添加售后订单</el-button
          >
          <el-button type="primary" size="mini" @click="handleExport" plain v-hasPermi="['order:afterorder:export']">导出</el-button>
        </div>
      </div>
      <el-table
        v-loading="listLoading"
        :data="list"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
        :row-class-name="tableRowClassName"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column
          :min-width="item.width"
          v-for="(item, index) in dynamicHeaders"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :fixed="item.prop === 'orderNum'"
          :sortable="item.isSortable"
          :show-overflow-tooltip="item.showToolTip"
        >
          <template slot-scope="{ row }">
            <el-link
              type="primary"
              @click="handleShow(row)"
              v-if="item.prop === 'orderNum'"
              >{{ row.orderNum }}</el-link
            >
            <template v-else-if="item.prop === 'custName'">
              <div class="tableDiv-txt" v-if="row.customerInfo">
                <span
                  >姓名:{{ row.customerInfo && row.customerInfo.name }}</span
                >
                <span
                  >手机号:{{ row.customerInfo && row.customerInfo.pho }}</span
                >
                <span v-if="row.addr && row.addr.length > 0"
                  >所属区域:{{ row.addr[0].regionName
                  }}{{ row.addr[1].regionName
                  }}{{ row.addr[2] && row.addr[2].regionName }}</span
                >
              </div>
            </template>
            <template v-else-if="item.prop === 'goodsList'">
              <span v-for="(item, index) in row.goodsList" :key="index">
                {{ item.afterGoodsName }}*{{ item.afterGoodsCount
                }}{{ row.goodsList.length - 1 != index ? "," : "" }}
              </span>
            </template>
            <span v-else-if="item.prop === 'operatePO'">{{
              row[item.prop] && row[item.prop].realName
            }}</span>
            <span v-else>{{ row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230" fixed="right">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" @click="handleAgree(row)">同意售后</el-button>
            <el-button type="text" @click="handleRefuse(row)">拒绝售后</el-button> -->
            <el-button
              type="text"
              @click="handleSureClaim(row)"
              v-if="row.customerInfo"
              >确认认领</el-button
            >
            <el-button
              type="text"
              @click="handleEndClaim(row)"
              v-if="row.customerInfo"
              >终止售后</el-button
            >
            <el-button type="text" @click="handleEdit(row)">认领客户</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :pageNo.sync="query.pageNo"
        :pageSize.sync="query.pageSize"
        @pagination="doQueryList"
      />
    </el-card>
    <change-fields-vue
      ref="fieldsPopup"
      :allTemplate="allTemplate"
      :cList="dynamicHeaders"
      @updated="doColumnList"
    />
    <claim-add ref="claimAdd" @created="doQueryList({})" />
    <claim-refuse ref="claimRefuse" @created="doQueryList({})" />
    <!-- 添加售后 -->
    <order-add ref="orderAdd" @created="doQueryList({})" />
  </div>
</template>
<script>
import goodsOrderApi from "@/api/order/goodsOrder";
import Pagination from "@/components/Pagination";
import changeFieldsVue from "@/views/common/changeFields.vue";
import claimAdd from "./add.vue";
import claimRefuse from "./refuse.vue";
import orderAdd from "../afterorder/add.vue";
export default {
  components: {
    Pagination,
    changeFieldsVue,
    claimAdd,
    claimRefuse,
    orderAdd
  },
  data() {
    return {
      query: {
        pageNo: 1,
        pageSize: 10
      },
      dateTime: [],
      listLoading: false,
      list: [],
      total: 0,
      fullscreenLoading: false,
      uploadImgUrl: "", // 上传地址（使用 http-request 时可以为空）
      fileList: [], // 文件列表
      allTemplate: [
        { label: "售后编号", prop: "orderNum" },
        { label: "申请人信息", prop: "custName", width: "170px" },
        { label: "申请商品", prop: "goodsList", showToolTip: true },
        { label: "申请商品总数量", prop: "totalCount" },
        { label: "申请时间", prop: "applyTime", width: "120px" },
        { label: "操作时间", prop: "operatedTime", width: "120px" },
        { label: "操作人", prop: "operatePO" }
      ],
      dynamicHeaders: []
    };
  },
  created() {
    this.doQueryList({});
    this.getFieled();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.rejectSignedTime) {
        return "warning-row";
      }
      return "";
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 });
    },
    handleAdd() {
      this.$refs.claimAdd.handleAdd();
    },
    handleEdit(row) {
      this.$refs.claimAdd.handleEdit(row);
    },
    handleAgree(row) {
      this.$refs.orderAdd.handleAddOrder(row.id, 1);
    },
    getFieled() {
      if (localStorage.getItem("claimTableColumn")) {
        let tColumn = JSON.parse(localStorage.getItem("claimTableColumn"));
        this.dynamicHeaders = tColumn;
      } else {
        this.dynamicHeaders = this.allTemplate;
      }
      console.log(this.dynamicHeaders);
    },
    handleChangeFields() {
      this.$refs.fieldsPopup.open();
    },
    doColumnList(checkedList) {
      if (checkedList && !checkedList.length) return;
      let allList = JSON.parse(JSON.stringify(this.allTemplate));
      let newL = allList.filter(item => checkedList.indexOf(item.prop) > -1);
      this.dynamicHeaders = newL;
      localStorage.setItem("claimTableColumn", JSON.stringify(newL));
    },
    calcQuery() {
      let { timeType } = this.query;
      if (timeType && this.dateTime && this.dateTime.length > 0) {
        this.query.startTime = this.dateTime[0];
        this.query.endTime = this.dateTime[1];
      } else {
        this.query.startTime = undefined;
        this.query.endTime = undefined;
      }
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo;
      }
      if (pageSize) {
        this.query.pageSize = pageSize;
      }
      this.calcQuery();
      this.listLoading = true;
      return goodsOrderApi
        .findManegeAfterOrderListByPage(this.query)
        .then(res => {
          let { list, total } = res.data;
          // list.forEach(item => {
          //   item.operateTime = item.operatePO && item.operatePO.operatedTime
          // })
          this.list = list;
          this.total = total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleFilter() {
      this.query = {};
      this.dateTime = [];
      this.doQueryList({ pageNo: 1 });
    },
    handleDownload() {
      goodsOrderApi.downloadImportTemplate();
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      goodsOrderApi.importExcelClaim(formData).then(res => {
        if (res.code === "0") {
          this.$message.success(res.msg || "操作成功");
          this.doQueryList({});
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleRefuse(row) {
      this.$refs.claimRefuse.handleRefuse(row);
    },
    handleShow(row) {
      this.$emit("handleShow", row, 2);
    },
    handleSureClaim(row) {
      this.$common
        .confirm("是否确认认领该售后订单？", "提示")
        .then(() => goodsOrderApi.confirmClaim({ id: row.id }))
        .then(() => {
          this.$common.showMsg("success", "操作成功");
          this.doQueryList({ pageNo: 1 });
        });
    },
    handleEndClaim(row) {
      this.$common
        .confirm("是否确认终止售后!", "提示")
        .then(() => goodsOrderApi.afterEnd({ id: row.id }))
        .then(() => {
          this.$common.showMsg("success", "操作成功");
          this.doQueryList({ pageNo: 1 });
        });
    },
    // 处理表格选择变化
    handleSelectionChange(selection) {
      // 可以在这里处理选中的行
      console.log("选中的行:", selection);
    },
    // 处理表格排序变化
    handleSortChange({ column, prop, order }) {
      // 可以在这里处理排序
      if (prop && order) {
        this.query.sortField = prop;
        this.query.sortOrder = order === "ascending" ? "asc" : "desc";
        this.doQueryList({ pageNo: 1 });
      } else {
        delete this.query.sortField;
        delete this.query.sortOrder;
        this.doQueryList({ pageNo: 1 });
      }
    },
    //导出
    handleExport() {
      this.$router.push("/export/list?code=EEForAfterOrderOther")
    },
  }
};
</script>
<style>
.block {
  padding: 20px 0;
}
.el-pagination {
  display: flex;
  justify-content: center;
}
.tableDiv-txt {
  display: flex;
  flex-direction: column;
}
.dialogDiv .el-select {
  display: block !important;
}
.vector {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-left: 10px;
}
.warning-row {
  background-color: #fdecec !important;
}
</style>
